import React, { useState, useEffect } from 'react';
//import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
//  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  IconButton,
  Button,
  LinearProgress 
} from '@material-ui/core';

import VisibilityIcon from '@material-ui/icons/Visibility';

import { StatusBullet } from 'components';

import { IsNoU, adCheckStatus } from 'common/utils';

//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row1: {
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(6),
    '& > *': {
      marginLeft: theme.spacing(0),
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  // avatar: {
  //   marginRight: theme.spacing(2)
  // },
  actions: {
    justifyContent: 'flex-end'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

// const statusColors = {
//   delivered: 'success',
//   pending: 'info',
//   refunded: 'danger'
// };

const TemplateTable = props => {
  const { 
    className, 

    userRole,

    advertises, 
    onSetSelectedAdvertises, 
    onClickPreview, 

    onClickOpenRegisterDialog,
    onClickOpenEditDialog,
    onClickOpenDeleteDialog,
    disableEditButton,
    disableDeleteButton,

    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest } = props;

  const classes = useStyles();

  //const [openProgress, setOpenProgress] = useState(false);

  const [selectedAdvertises, setSelectedAdvertises] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedAdvertises;

    if (event.target.checked) {
      selectedAdvertises = advertises.map(advertise => advertise.id);
    } else {
      selectedAdvertises = [];
    }

    setSelectedAdvertises(selectedAdvertises);
    onSetSelectedAdvertises(selectedAdvertises);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedAdvertises.indexOf(id);
    let newSelectedAdvertises = [];

    if (selectedIndex === -1) {
      newSelectedAdvertises = newSelectedAdvertises.concat(selectedAdvertises, id);
    } else if (selectedIndex === 0) {
      newSelectedAdvertises = newSelectedAdvertises.concat(selectedAdvertises.slice(1));
    } else if (selectedIndex === selectedAdvertises.length - 1) {
      newSelectedAdvertises = newSelectedAdvertises.concat(selectedAdvertises.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedAdvertises = newSelectedAdvertises.concat(
        selectedAdvertises.slice(0, selectedIndex),
        selectedAdvertises.slice(selectedIndex + 1)
      );
    }

    setSelectedAdvertises(newSelectedAdvertises);
    onSetSelectedAdvertises(newSelectedAdvertises);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  //   setPage(0);
  // };

  useEffect(() => {
    //console.log('componentDidUpdate & advertises changed');

    const newSelected = selectedAdvertises.filter(id => {
      const findObj = advertises.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedAdvertises(newSelected);
    onSetSelectedAdvertises(newSelected);

  }, [advertises]);

  return (
    <div>
      <div className={classes.row} spacing={2}>
        {userRole !== 'user' && (
          <>
            <Button
              color="primary"
              variant="contained"
              onClick={ onClickOpenRegisterDialog }
            >
              등록
            </Button>

            <Button
              color="primary"
              variant="contained"
              disabled={ disableEditButton }
              onClick={ onClickOpenEditDialog }
            >
              수정
            </Button>

            <Button
              style={{
                //  borderRadius: 35,
                  backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                  color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                  // padding: "18px 36px",
                  // fontSize: "18px"
                }}
              variant="contained"
              disabled={ disableDeleteButton }
              onClick={ onClickOpenDeleteDialog }
            >
              삭제
            </Button>
          </>
        )}

        <div className={classes.row1}>
          <StatusBullet
            className={classes.status}
            color={'success'}
            size="md"
          />

          <Typography
            className={classes.root}
            color="textSecondary"
            gutterBottom
          >
            유효
          </Typography>

          <StatusBullet
            className={classes.status}
            color={'primary'}
            size="md"
          />

          <Typography
            className={classes.root}
            color="textSecondary"
            gutterBottom
          >
            예약
          </Typography>

          <StatusBullet
            className={classes.status}
            color={'danger'}
            size="md"
          />

          <Typography
            className={classes.root}
            color="textSecondary"
            gutterBottom
          >
            종료
          </Typography>
        </div>

      </div>

      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {openProgress && <LinearProgress />}
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={advertises.length > 0 && selectedAdvertises.length === advertises.length}
                        color="primary"
                        indeterminate={
                          selectedAdvertises.length > 0 &&
                          selectedAdvertises.length < advertises.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>광고명</TableCell>
                    <TableCell>광고대행사</TableCell>
                    <TableCell>광고주</TableCell>
                    <TableCell>재생시간</TableCell>
                    <TableCell>수정자</TableCell>
                    <TableCell>수정일</TableCell>
                    <TableCell>기간현황</TableCell>
                    <TableCell>미리보기</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {advertises.slice(0, rowsPerPage).map((advertise, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={advertise.id}
                      selected={selectedAdvertises.indexOf(advertise.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedAdvertises.indexOf(advertise.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, advertise.id)}
                          value="true"
                          //disabled={checkDeletable(advertise)}
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{advertise.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{advertise.agency}</TableCell>
                      <TableCell>{advertise.client}</TableCell>
                      {/* <TableCell>{Math.floor(advertise.playtime/60) + '분'}</TableCell> */}
                      <TableCell>{advertise.playtime + '초'}</TableCell>
                      <TableCell>{advertise.modified_user}</TableCell>
                      <TableCell>
                        {moment(advertise.modified_at).format('YYYY-MM-DD')}
                      </TableCell>
                      <TableCell>
                        <StatusBullet
                            className={classes.status}
                            color={adCheckStatus(advertise)}
                            size="md"
                          />
                      </TableCell>
                      <TableCell> 
                        <IconButton 
                          arai-label="view"
                          onClick={() => { onClickPreview(advertise) }} >
                          <VisibilityIcon /> 
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            labelRowsPerPage=''
            component="div"
            //count={advertises.length}
            count={item_total}
            onChangePage={onPageChange}
            onChangeRowsPerPage={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
     
    </div>
  );
};

TemplateTable.propTypes = {
  className: PropTypes.string,
  advertises: PropTypes.array.isRequired,
  item_total: PropTypes.number,
};

TemplateTable.defaultProps = {
  item_total: 0,
//  updateCategoryChecks: () => {},
};

// const mapStateToProps = state => ({
// //  templates: state.templates.templateList,
// //  checks: state.templates.templateChecks
// });

// const mapDispatchToProps = dispatch => ({
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(TemplateTable);
export default TemplateTable;
